/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareUpIcon24Solid = forwardRef('ArrowFigureASquareUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 17.5A4.5 4.5 0 0 0 6.5 22h11a4.5 4.5 0 0 0 4.5-4.5v-11A4.5 4.5 0 0 0 17.5 2h-11A4.5 4.5 0 0 0 2 6.5v11Zm5.293-6.246a1 1 0 0 0 1.414 0L11 8.961V17a1 1 0 1 0 2 0V8.961l2.293 2.293a1 1 0 1 0 1.414-1.414l-3.006-3.006a2.406 2.406 0 0 0-3.402 0L7.293 9.84a1 1 0 0 0 0 1.414Z" })));
});
